module.exports = __webpack_public_path__ + "media/images/pic/anime/heart-0475fa22ad5101bdcaa6803c811c5106.svg";